import { useMemo } from 'react';

//* HOC's
import { withDataContext } from 'context';

//* Components
import Page from 'components/common/Page';
import Feedback from 'components/common/Feedback';
import Container from 'components/common/Container';
import PageBuilder from 'components/common/PageBuilder';
import RelatedPages from 'components/common/RelatedPages';
import UpcomingEvents from 'components/common/UpcomingEvents';
import RelatedBlogPosts from 'components/common/RelatedBlogPosts';

const AboutArmenia = ({ singlePage, pageParams, selectedLang }) => {
	const pageData = useMemo(() => singlePage?.[pageParams.selectedSlug]?.[selectedLang], [singlePage, pageParams, selectedLang]);

	return (
		<Page
			meta={pageData?.meta}
			transparentHeader={pageParams.transparentHeader && !pageData}
		>
			<PageBuilder
				components={pageData?.components}
				type={pageData?.type}
				pageId={pageData?.id}
			/>

			{pageData && (
				<Container section>
					<Feedback
						type={pageData?.feedbackType}
						typeId={pageData?.id}
					/>
				</Container>
			)}

			{pageData?.events?.length > 0 && <UpcomingEvents events={pageData.events} />}

			{pageData?.articles?.length > 0 && <RelatedBlogPosts articles={pageData.articles} />}

			{pageData?.relatedPages?.length > 0 && <RelatedPages relatedPages={pageData.relatedPages} />}
		</Page>
	);
};

export default withDataContext(AboutArmenia, ['singlePage']);
